"use strict";
function vectorToAngle(vector) {
    return Math.atan2(-vector.data[2], vector.data[0]);
}
exports.vectorToAngle = vectorToAngle;
function angleToVector(outVector, angle) {
    outVector.data[2] = -Math.sin(angle);
    outVector.data[1] = 0;
    outVector.data[0] = Math.cos(angle);
    return outVector;
}
exports.angleToVector = angleToVector;
//# sourceMappingURL=SteeringUtils3D.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/controls/CommandControl/SteeringUtils3D.js
 ** module id = 336
 ** module chunks = 0
 **/